import {FrontendFiltersOrderSearch} from "./FrontendFiltersOrderSearch";
import {FrontendFilterValues} from "@/components/FrontendFilters/structs";
import store from "@/store";
import _ from "lodash"

export class FrontendFiltersPickByStoreSearch extends FrontendFiltersOrderSearch {
    subIdentifier = 'pick-by-store';

    pageTitleLanguageKey = `frontend-filters.page-titles.pick-by-store`;
    pageIcon = 'pe-7s-search';

    getResultLink(result: Record<string,string>, filterValues: FrontendFilterValues): Record<string,any> {
        return {
            name: 'OrderPickByStoreScan',
            params: {
                salesOrderIdentifier: result.order_identifier,
                // @ts-ignore
                dispatchRequestId: result.current_dispatch_requests_with_paused[0]?.id,
            },
        }
    };
}

